<template>
  <div class="bg-white m-md-5 m-0 p-4">
    <b-row>
      <b-col cols="12" md="12" class="text-center d-md-none">
        <img
          class="navbar-brand-full image-payment"
          :src="$config.images.tinyLogo"
          alt="Logo"
        />
      </b-col>
      <b-col cols="12" md="10" class="text-md-left text-center">
        <h3 v-text="$lang.project_title" />
        <p class="text-muted" v-text="$lang.project_description" />
      </b-col>
      <b-col cols="12" md="2" class="text-right d-md-inline d-none">
        <img
          class="navbar-brand-full image-payment"
          :src="$config.images.tinyLogo"
          alt="Logo"
        />
      </b-col>
      <b-col cols="12" md="12">
        <LoadingSpinner :loading="loading" :text="loadingText" />
      </b-col>
      <b-col v-if="!loading" class="mt-3 border-top pt-4">
        <slot name="header" />
      </b-col>
      <b-col v-if="!loading" cols="12" class="mb-4 p_15_50">
        <b-list-group
          v-if="showContent"
          id="section-to-print"
          class="width-percent-100"
        >
          <b-list-group-item class="text-center bg-dark text-white fs_16">
            <b v-text="label" />
          </b-list-group-item>
          <b-list-group-item
            v-for="(item, index) in generateListItems"
            :key="index"
            class="d-flex justify-content-between align-items-center border-dark bg-light"
          >
            <div class="d-flex align-items-center">
              <i :class="`${item.icon} fa-lg mr-2`" />
              <b v-text="item.label" />
            </div>
            <b
              v-if="item.type === 'text'"
              class="text-primary fs_16"
              v-text="item.value"
            />
            <img
              v-if="item.type === 'image'"
              class="img-thumbnail bg-white"
              width="64"
              :src="item.value"
            />
          </b-list-group-item>
        </b-list-group>
      </b-col>
      <b-col v-if="!loading">
        <slot name="footer" />
      </b-col>
      <b-col cols="12" md="12" class="text-center border-top pt-4">
        <slot name="buttons" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { pathOr } from "ramda";

export default {
  components: {
    LoadingSpinner,
  },
  props: {
    items: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    loadingText: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    showContent: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    generateListItems() {
      let price = pathOr(0, ["amount"], this.items);
      price = price ? this.spliceNumber(price) : 0;
      const nowTime = this.$moment().format("jYYYY/jMM/jDD HH:mm:ss");
      return [
        {
          type: "text",
          icon: "far fa-check-circle",
          label: "مبلغ قابل پرداخت:",
          value: `${price} ریال`,
        },
        {
          type: "text",
          icon: "far fa-clock",
          label: "زمان پرداخت:",
          value: pathOr(nowTime, ["created_at2", "jalali"], this.items),
        },
        {
          type: "text",
          icon: "fas fa-credit-card",
          label: "شماره کارت:",
          value: pathOr("*".repeat(16), ["card_no"], this.items),
        },
        {
          type: "text",
          icon: "fas fa-hashtag",
          label: "شماره پیگیری:",
          value: pathOr("*".repeat(10), ["tracking_code"], this.items),
        },
        {
          type: "text",
          icon: "fas fa-link",
          label: "آدرس وبسایت:",
          value: pathOr(window.location.origin, ["site_url"], this.items),
        },
        {
          type: "image",
          icon: "fas fa-desktop",
          label: "درگاه پرداخت:",
          value: this.generateBankLogo(
            pathOr("mellat", ["gate_name"], this.items)
          ),
        },
      ];
    },
  },

  methods: {
    pathOr,
    spliceNumber(number) {
      if (number) {
        if (typeof number == "number") {
          return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        } else {
          return number.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        }
      }
    },
    generateBankLogo(key) {
      return pathOr("", [key], this.$config.images.shared.bankLogo);
    },
    print() {
      window.print();
    },
  },
};
</script>

<style>
@media (min-width: 575.98px) {
  .p_15_50 {
    padding: 15px 50px !important;
  }
}
.img-bank {
  width: 250px;
}

.visible-hidden {
  visibility: hidden;
}

.image-payment {
  width: 75px;
}

.card-payment {
  background: #17b5f0;
  padding: 10px;
  color: white;
  font-size: 15px;
  font-weight: bold;
}

.thead-payment {
  background: #17b5f0;
  color: white;
}

.cost {
  background: gray;
  padding: 10px;
  color: white;
  font-size: 15px;
  font-weight: bold;
}
</style>
